import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import { Form, Input, Modal, notification } from 'antd'
import { updateExamineeCheckStatus } from '../../common/request'
import ResponseCode from '../../common/response-code'
import { useSelector } from 'react-redux'
import CheckSuggestionInputHints from './CheckSuggestionInputHints'

const RefuseCheckModal = forwardRef((props, ref) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [forbidReapplyPosition, setForbidReapplyPosition] = useState(false)
  const [suggestionResetKey, setSuggestionResetKey] = useState(0)
  const userInfo = useSelector(state => state.userInfo.userInfo)
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const orgId = props.orgId || selectedExam?.orgId

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = (options = {}) => {
    form.resetFields()
    setForbidReapplyPosition(!!options.forbidReapplyPosition)
    setSuggestionResetKey((key) => key + 1)
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    setForbidReapplyPosition(false)
    form.resetFields()
    setSuggestionResetKey((key) => key + 1)
  }

  const applySuggestion = useCallback((suggestion) => {
    form.setFieldsValue({ noApprovedReason: suggestion })
  }, [form])

  const onOk = () => {
    form.validateFields().then(fields => {
      setLoading(true)
      const params = {
        ...fields,
        applyInfoId: props.examineeItem.applyInfoId || props.examineeItem.id,
        auditStatus: -1,
        optLock: props.applyInfo.optLock,
        userName: userInfo.realName,
        ...(forbidReapplyPosition ? { forbidReapplyPosition: true } : {})
      }

      updateExamineeCheckStatus(params, userInfo.currentRoleTag).then(res => {
        setLoading(false)
        if (res.code === ResponseCode.success) {
          notification.success({
            message: '操作成功'
          })
          hideModal()
          props.insertSuccess?.()
        } else {
          Modal.error({
            title: '错误',
            content: res.msg
          })
        }
      }).catch(err => {
        console.error(err)
        setLoading(false)
        Modal.error({
          title: '错误',
          content: '网络错误，修改审核状态失败'
        })
      })

    }).catch(err => {
      console.error(err)
    })
  }

  const modalTitle = forbidReapplyPosition
    ? '审核不通过，且禁止报考本岗位'
    : '审核不通过'

  return (
    <div ref={ ref }>
      <Modal
        title={ modalTitle }
        centered={ true }
        open={ modalVisible }
        onOk={ onOk }
        confirmLoading={ loading }
        onCancel={ hideModal }
      >
        <div className="py-3">
          {
            modalVisible
              ? (
                <CheckSuggestionInputHints
                  key={ suggestionResetKey }
                  orgId={ orgId }
                  resetKey={ suggestionResetKey }
                  onSelect={ applySuggestion }
                />
              )
              : null
          }
          <Form form={ form } layout="vertical">
            <Form.Item
              label="审核不通过原因"
              name="noApprovedReason"
              required
              rules={ [{ required: true, message: '请输入审核不通过原因' }] }
            >
              <Input.TextArea
                maxLength={ 200 }
                showCount
                rows={ 4 }
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  )
})

export default RefuseCheckModal
